export function clear() {
    return {
        type: 'USER_CLEAR'
    };
}
